// extracted by mini-css-extract-plugin
export var htmlPreview = "_or-2";
export var modal = "_or-0";
export var sidebar = "_or-1";